export const printDatasheet = ({
  printableElement,
  pixelsToSkip,
}: {
  printableElement: HTMLDivElement;
  pixelsToSkip?: number;
}) => {
  const getCurrentStyles = () => {
    const head = document.getElementsByTagName("head")[0];

    let styles = "";

    const styleNodeName = "STYLE";

    if (head) {
      for (let i = 0; i < head.childNodes.length; i++) {
        const node = head.childNodes[i] as HTMLDivElement;

        if (styleNodeName == node.nodeName) {
          styles = styles + "\n" + (head.childNodes[i] as HTMLDivElement).innerHTML;
        }
      }
    }

    return styles + "\n";
  };

  const printableContent = `
              <html>
              <head>
                  <style>
                      ${getCurrentStyles()}
                  </style>
              </head>
              <body onload='setTimeout(function(){window.print();}, 500);'  style='overflow: visible; margin-left:-${
                pixelsToSkip || 0
              }px;'>
                 ${printableElement.outerHTML}
              </body>
              </html>
            `;

  var printingWindow = window.open("", "_blank", "width=900px, height=600px, resizable");
  var doc = (printingWindow as Window).document;

  doc.open();
  doc.write(printableContent);
  doc.close();
};
